import React, { createContext, useEffect, useState } from "react";
import axios from "axios";

export const DollarContext = createContext();

const fetchDollarPrice = async () => {
  const response = await axios.get(
    "https://api.coingecko.com/api/v3/simple/price?ids=tether&vs_currencies=brl"
  );
  return response.data.tether.brl;
};

export const DollarProvider = ({ children }) => {
  const [dollarPrice, setDollarPrice] = useState(null);

  useEffect(() => {
    const getDollarPrice = async () => {
      try {
        const price = await fetchDollarPrice();
        const formattedValue = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(price);
        setDollarPrice(formattedValue);
      } catch (error) {
        console.error("Erro ao buscar a cotação do dólar:", error);
      }
    };

    getDollarPrice();
  }, []);

  return (
    <DollarContext.Provider value={dollarPrice}>
      {children}
    </DollarContext.Provider>
  );
};
